/* import __COLOCATED_TEMPLATE__ from './do-more-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();